import axios from "@/api/axios";
import store from "@/store";
import _ from "lodash";
import qs from "qs";

// 포인트리스트 가지고 오기
const get_pointlist = async (param, result) => {
  let finalData = {
    code: "",
    message: "",
    pageno: 1,
    pointlistcnt: 0,
    pointlist: [],
  };
  const token = sessionStorage.getItem("token") || null;
  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/halloffame/pointlist",
    //url: 'http://localhost/test.php',
    //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    headers: { Authorization: "Bearer " + token },
    params: {
      pointtype: param.pointtype,
      searchname: param.searchname,
      searchtype: param.searchtype,
      searchdate: param.searchdate,
      pageno: param.pageno,
      pagesize: param.pagesize,
    },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_pointlist", err);
    result(false, err);
  }
};
// stats 가지고 오기
const get_statslist = async (param, result) => {
  let finalData = {
    code: "",
    message: "",
    pageno: 1,
    listcnt: 0,
    list: [],
  };
  const token = sessionStorage.getItem("token") || null;
  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/halloffame/statslist",
    //url: 'http://localhost/test.php',
    //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    headers: { Authorization: "Bearer " + token },
    params: {
      rank_field: param.rank_field,
      sort: param.sort,
      searchname: param.searchname,
      searchtype: param.searchtype,
      searchdate: param.searchdate,
      pageno: param.pageno,
      pagesize: param.pagesize,
      country_fk: param.country_fk || "", // 추가
      states_fk: param.states_fk || "", // 추가
      owner_fk: param.owner_fk || "", // 추가
    },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_statslist", err);
    result(false, err);
  }
};

// stats 가지고 오기
const get_stats_summary = async (param, result) => {
  let finalData = {
    code: "",
    message: "",
    summary: {},
  };
  const token = sessionStorage.getItem("token") || null;
  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/halloffame/stats_summary",
    //url: 'http://localhost/test.php',
    //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    headers: { Authorization: "Bearer " + token },
    params: {
      searchdate: param.searchdate,
    },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_stats_summary", err);
    result(false, err);
  }
};

// stats 가지고 오기
const get_stats_filter = async (param, result) => {
  let finalData = {
    code: "",
    message: "",
    pageno: 1,
    listcnt: 0,
    list: [],
  };
  const token = sessionStorage.getItem("token") || null;
  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/halloffame/stats_filter",
    //url: 'http://localhost/test.php',
    //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    headers: { Authorization: "Bearer " + token },
    params: {
      rank_field: param.rank_field,
      sort: param.sort,
      searchdate: param.searchdate,
    },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_statslist", err);
    result(false, err);
  }
};

const get_livestatslist = async (param, result) => {
  let finalData = {
    code: "",
    message: "",
    pageno: 1,
    listcnt: 0,
    list: [],
  };
  const token = sessionStorage.getItem("token") || null;
  const options = {
    method: "GET",
    url: process.env.VUE_APP_API_URL + "/halloffame/livestatslist",
    //url: 'http://localhost/test.php',
    //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    headers: { Authorization: "Bearer " + token },
    params: {
      rank_field: param.rank_field,
      sort: param.sort,
      searchname: param.searchname,
      searchtype: param.searchtype,
      searchdate: param.searchdate,
      pageno: param.pageno,
      pagesize: param.pagesize,
      country_fk: param.country_fk || "", // 추가
      states_fk: param.states_fk || "", // 추가
      owner_fk: param.owner_fk || "", // 추가
    },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_livestatslist", err);
    result(false, err);
  }
};

export default {
  get_pointlist,
  get_statslist,
  get_livestatslist,
  get_stats_summary,
  get_stats_filter,
};
